// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--leWMx","active":"a10a3f92e9--active--rKimO"};